<template>
  <tr class="even:bg-white odd:bg-gray-50">
    <td class="px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-900 tabular-nums">
      <div class="flex items-center">
        <img class="h-10 w-10 rounded-full" :src="account.logo" :alt="account.name" />
        <div class="ml-3">
          <RouterLink :to="toAccountRoute" target="_blank">
            {{ account.name }}
          </RouterLink>
        </div>
      </div>
    </td>
    <td class="px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-900 tabular-nums">
      {{ account.jobPosition || '-' }}
    </td>
    <td class="px-4 py-4 text-right">
      <div class="space-x-2 whitespace-nowrap">
        <AccountEditAction
          :contact-id="contactId"
          :account="account"
          @account-updated="onAccountUpdated"
        />
        <AccountRemoveAction
          :contact-id="contactId"
          :account="account"
          @account-removed="onAccountRemoved"
        />
      </div>
    </td>
  </tr>
</template>

<script>
import AccountEditAction from './AccountEditAction.vue';
import AccountRemoveAction from './AccountRemoveAction.vue';

export default {
  components: {
    AccountEditAction,
    AccountRemoveAction,
  },
  props: {
    account: {
      type: Object,
      required: true,
    },
    contactId: {
      type: String,
      required: true,
    },
  },
  computed: {
    toAccountRoute() {
      return {
        name: 'accounts.show',
        params: {
          accountId: this.account.id,
        },
      };
    },
  },
  methods: {
    onAccountUpdated() {
      this.$emit('account-updated');
    },
    onAccountRemoved(removedAccount) {
      this.$emit('account-removed', removedAccount);
    },
  },
};
</script>
